import { render, staticRenderFns } from "./Icon_Circle.vue?vue&type=template&id=28f126ac&scoped=true&"
import script from "./Icon_Circle.vue?vue&type=script&lang=js&"
export * from "./Icon_Circle.vue?vue&type=script&lang=js&"
import style0 from "./Icon_Circle.vue?vue&type=style&index=0&id=28f126ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f126ac",
  null
  
)

export default component.exports